import React from 'react';

const ProjectCard = ({ project }) => {
  return (
    <div className="w-full flex items-start justify-center p-2 sm:p-4 md:p-6">
      <div className="w-full max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row bg-gradient-to-br from-gray-50 to-gray-100 dark:from-zinc-900 dark:to-zinc-950 rounded-2xl overflow-hidden shadow-lg">
          {/* Project Image (Desktop only) */}
          <div className="hidden md:block md:w-1/2 h-56 md:h-80 lg:h-96 relative overflow-hidden flex-shrink-0">
            <img
              src={project.image}
              alt={project.title}
              className="object-cover w-full h-full"
            />
          </div>

          {/* Project Info */}
          <div className="w-full md:w-1/2 px-4 md:px-8 py-6 flex flex-col justify-center">
            <span className="mb-2 px-3 py-1 text-xs sm:text-sm font-medium rounded-full w-fit border border-gray-300 dark:border-zinc-700 bg-white/80 dark:bg-zinc-800/60 text-gray-700 dark:text-gray-200">
              {project.category}
            </span>

            <h2 className="text-lg sm:text-xl md:text-2xl font-bold tracking-tight text-indigo-700 dark:text-indigo-300 mb-2">
              {project.title}
            </h2>

            <p className="text-sm sm:text-base md:text-lg text-gray-700 dark:text-gray-300 leading-relaxed mb-4 max-h-32 md:max-h-40 overflow-y-auto">
              {project.description}
            </p>

            <div className="flex flex-wrap gap-2 mb-5">
              {project.tags.map((tag) => (
                <span key={tag} className="px-2 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-full text-xs sm:text-sm font-medium">
                  {tag}
                </span>
              ))}
            </div>

            <a
              href={project.link || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="group w-fit border border-indigo-200 dark:border-indigo-700 px-4 py-2 rounded-lg text-sm md:text-base font-semibold text-indigo-700 dark:text-indigo-300 bg-indigo-50 dark:bg-indigo-900/20 hover:bg-indigo-100 dark:hover:bg-indigo-800/40 transition-colors flex items-center"
            >
              View Project
              <span className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1 mb-2">
                →
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
